<template>
  <div class="view-more-layout" >
    <portal-target name="filter-overlay-list" class="overlay-portal" />
    <div class="view-more-contents" ref="contentsOverlay">
      <div class="common-header">
        <view-more-header :title-list="titleList" :close-fn="close"></view-more-header>
      </div>
      <div class="view-more-component-container" data-scroll-element="true">
        <portal-target name="filter-overlay" class="overlay-portal" />
        <infinite-scroll-cell-list v-if="cellList && cellList.length"
                                   key="infinite-scroll-cell-list"
                                   :cell-list="cellList"
                                   :thumbnail-info="thumbnailInfo"
                                   :container-class-name="getCellListContainerClassName"
                                   v-on:load-more="loadMore"
        />
        <div v-if="showEmptyList" class="empty-cell-list">
          <div class="attention-mark-area">
            <empty-image></empty-image>
          </div>
          <div class="text-area">
            해당데이터가 없습니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmptyImage from '@/assets/svg/common/img_empty.svg'
import { get } from 'lodash'
import EventModelClass from '@/common/model/EventModelClass'
import InfiniteScrollCellList from '@/components/section/template/cell/InfiniteScrollCellList'
import ViewMoreHeader from '@/components/header/template/ViewMoreHeader'
import { EventService } from '@/common/api/api.service'
import { getBandTypeInfoByCellType } from '@/common/image.util'
export default {
  name: 'InstantPlayList',
  components: {
    EmptyImage,
    InfiniteScrollCellList,
    ViewMoreHeader
  },
  data () {
    return {
      showEmptyList: false,
      currentEvent: {},
      offset: 0,
      limit: 20,
      titleList: [],
      cellList: [],
      thumbnailInfo: {}
    }
  },
  computed: {
    getCellListContainerClassName () {
      const type = this.thumbnailInfo.cellType === 'band_82' ? 'autoplay' : this.thumbnailInfo.type
      return `cell-list responsive cell-${type}`
    }
  },
  methods: {
    close () {
      const referer = get(this.$route, ['query', 'referer'], null)
      if (referer !== null) {
        this.$router.replace(referer)
      } else {
        const came = get(this.$route, ['query', 'came'], null)
        if (came !== null && came !== '') {
          this.$router.push({ name: came })
        } else {
          this.$router.back()
        }
      }
    },
    loadMore () {
      if (this.endOfList) return
      const eventInstance = new EventModelClass(this.currentEvent)
      eventInstance.offset = this.offset
      eventInstance.limit = this.limit
      eventInstance.setPaging(true)
      this.setData(eventInstance)
    },
    setData (eventInstance) {
      if (this.isLoading) return
      this.isLoading = true
      EventService.requestEventData(eventInstance).then(({ data }) => {
        if (this.offset === 0) { // INFO : 처음에만
          this.titleList = get(data, ['cell_toplist', 'title_list'], [])
          this.topButtonList = get(data, ['cell_toplist', 'topbuttonlist'], [])
          this.thumbnailInfo = getBandTypeInfoByCellType(get(data, ['cell_toplist', 'cell_type'], ''))
        }
        let resCellList = get(data, ['cell_toplist', 'celllist'], [])
        this.showEmptyList = this.cellList.length === 0 && resCellList.length === 0
        if (resCellList.length === 0) { this.endOfList = true }
        this.offset += this.limit
        this.cellList = this.cellList.concat(resCellList)
        this.isLoading = false
      }).catch(() => {
        this.$router.replace('/')
      })
    }
  },
  created () {
    let text, url
    text = get(this.$route, ['params', 'text'], '')
    url = get(this.$route, ['query', 'api'], '')
    this.selectedCategoryTitle = text
    try {
      if (url !== '') {
        const eventInstance = new EventModelClass({ url: decodeURIComponent(url) })
        this.currentEvent = eventInstance
        this.setData(eventInstance)
      } else {
        let target = '/'
        if (this.$route.params.section !== 'home') {
          target = `/${this.$route.params.section}`
        }
        this.$router.replace(target)
      }
    } catch (e) {
      this.$router.push('/')
    }
  }
}
</script>
